import SectionCard from '../shared/SectionCard'
import { Stack } from './styled-components'
import CommandsForm from '@/containers/DevToolsNew/Commands/CommandsForm'

const CommandsPage = () => {
  return (
    <Stack>
      <SectionCard>
        <CommandsForm />
      </SectionCard>
    </Stack>
  )
}

export default CommandsPage
